import { getCookie } from "@/helpers/cookie";

export function getRoistatFromCookie() {
    return parseInt(getCookie("roistat_visit")) ?? null;
}